import { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { SHOULD_TRACK_SESSION, tracker } from "@utils/openreplay";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AppRouter } from "./app/AppRouter";
import {
  queryClient,
  SidebarMenuContextProvider,
  FetchProvider,
  AuthProvider,
  MedicineSearchProvider,
} from "@contexts";
import { WhatsAppSupportFab } from "./components/Buttons/WhatsAppSupportFab";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { theme } from "@mekidoc/ui";
import { useAppVersion } from "@hooks/useAppVersion";
import { clearChunkErrorReloadFlag } from "@utils";

const emotionCache = createCache({
  key: "mui",
  prepend: true,
  container: document.head,
  speedy: false,
  // speedy: true,
  // nonce: "1234567890",
  // insertionPoint: document.head,
});

function App() {
  const appVersion = useAppVersion();
  useEffect(() => {
    clearChunkErrorReloadFlag();
  }, []);
  useEffect(() => {
    if (SHOULD_TRACK_SESSION && tracker) {
      tracker.start({
        metadata: {
          version: appVersion,
        },
      });
      return () => {
        tracker?.stop();
      };
    }
  }, [appVersion]);
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <FetchProvider>
          <AuthProvider>
            <ThemeProvider theme={theme}>
              <CacheProvider value={emotionCache}>
                <SnackbarProvider preventDuplicate={true}>
                  <CssBaseline />
                  <MedicineSearchProvider>
                    <SidebarMenuContextProvider>
                      <AppRouter />
                      <WhatsAppSupportFab position="bottom-right" />
                    </SidebarMenuContextProvider>
                  </MedicineSearchProvider>
                </SnackbarProvider>
              </CacheProvider>
            </ThemeProvider>
          </AuthProvider>
        </FetchProvider>
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
